import checkIfOptionIsVisible from "./checkIfOptionIsVisible";
import updateResponsesObject from "./updateResponsesObject";
import checkIfBlockIsVisible from "./checkIfBlockIsVisible";

const getSelectQuestionsWithOneOption = (
  questions,
  value,
  block,
  checkAllQuestions,
  context,
  user
) =>
  questions.reduce((acc, question) => {
    if (
      checkAllQuestions ||
      ((block === undefined || question.id !== block.id) &&
        (question.input_type === "select" ||
          question.input_type === "multi_select") &&
        question.options?.length)
    ) {

      const isVisible = checkIfBlockIsVisible(question, context);

      if (!isVisible) {
        return acc;
      }
      const questionOptions = question.options.filter((o) =>
        checkIfOptionIsVisible(o, context, user, value)
      );

      if (questionOptions.length === 1) {
        return {
          ...acc,
          ...updateResponsesObject(
            null,
            question,
            /*
            HUBSPOT TICKET https://app.hubspot.com/contacts/8760420/record/0-5/18770049293/
            in case of multiselect question, the value should be an array of strings instead of a string
            same for the option, it should be an array of objects instead of an object
             */
            question.input_type === "select" ?`${questionOptions[0].id}`: [`${questionOptions[0].id}`],
            question.input_type === "select"? questionOptions[0]: [questionOptions[0]],
            undefined,
            context
          ),
        };
      }
    }
    return acc;
  }, {});

export default getSelectQuestionsWithOneOption;
